import {
  ON_START_GET_OFFERT_HOGIA_VARDE_TOOLTIP,ON_GET_OFFERT_HOGIA_VARDE_TOOLTIP,ON_ERROR_GET_OFFERT_HOGIA_VARDE_TOOLTIP,
  //
  OFFERTPREV_ON_LOAD_AUTO_FILL_INPUT_TYPES,
  OFFERTPREV_ON_LOAD_AUTO_FILL_INPUT_TYPES_FROM_LS,
  OFFERTPREV_ON_LOAD_CURRENT_OFFERT,
  OFFERTPREV_ON_UPDATE_INPUT_FIELD,
  OFFERTPREV_ON_UPDATE_CHECKBOX,
  OFFERTPREV_ON_ADD_OFFERT,
  OFFERTPREV_ON_LOAD_OFFERT,
  OFFERTPREV_ON_START_LOAD_OFFERT,
  OFFERTPREV_ON_GET_OFFERTS,
  OFFERTPREV_ON_UPDATE_OFFERT,
  OFFERTPREV_ON_MAP_INPUTS,
  OFFERTPREV_ON_UPDATE_MAP_INPUTS,
  OFFERTPREV_ON_SET_CUSTOMER,
  OFFERTPREV_LOAD_SELECTED_CUSTOMER,
  OFFERTPREV_ON_ADD_PRODUCT,
  OFFERTPREV_ON_DELETE_PRODUCT,
  OFFERTPREV_ON_CHANGE_PRODUCT_QNT,
  OFFERTPREV_ON_CHANGE_PRODUCT,
  OFFERTPREV_ON_LOAD_ARTIKLAR,
  OFFERTPREV_ON_ERROR_LOAD_ARTIKLAR,
  OFFERTPREV_ON_START_LOAD_ARTIKLAR,
  OFFERTPREV_ON_SUM_TOTAL,
  OFFERTPREV_ON_GET_OFFERT_COUNT,
  OFFERTPREV_ON_CHANGE_EDIT_TEXT,
  OFFERTPREV_ON_GET_DOCUMENTS,
  OFFERTPREV_ON_SEARCH_OFFERTS,
  OFFERTPREV_ON_GET_STATS,
  OFFERTPREV_ON_FETCH_ART,
  OFFERTPREV_ON_GET_ALL_OFFERTS,
  OFFERTPREV_ON_GET_AVTAL_OFFERTS,
  OFFERTPREV_ON_START_GET_ALL_OFFERTS,
  OFFERTPREV_ON_CHANGE_AVTALSTID,
  
  OFFERTPREV_ON_RESPOSE,
  OFFERTPREV_ON_RESPOSE_RESET,
  OFFERTPREV_ON_SET_LOADING,
  OFFERTPREV_ON_SET_LOADING_DONE,
  OFFERTPREV_ON_START_SEARCH_ART,
  OFFERTPREV_ON_SEARCH_ART,
  OFFERTPREV_ON_ADD_BILAGA,
  OFFERTPREV_ON_DELETE_PAGE,
  OFFERTPREV_ON_HIDE_PAGE,
  OFFERTPREV_ON_GET_BILAGOR,
  OFFERTPREV_ON_CHECK_TOTAL_SECTIONS_HEIGHT,
  OFFERTPREV_ON_ADD_PAGE,
  OFFERTPREV_ON_SET_PRODUCT_QNT,

  ON_OPEN_FILTER_OFFERT,
  ON_ClOSE_FILTER_OFFERT,
  SET_OFFERT_FILTER,
  SET_ZERO_OFFERT,
  ON_GET_OFFERT_PAGE_BASIC,
  ON_GET_OFFERT_PAGE_SIZE_BASIC
}  from '../constants/ActionTypes'

import { v4 as uuidv4 } from 'uuid';
import { indexOf, isNull, isUndefined, isEmpty } from 'lodash';



const INIT_STATE = {
  autoFillInputTypes: {},
  selectedKund: {
    name: 'test'
  },

  currentOffert: {},

  currentOffertTotalMånSum: 0,
  currentOffertProfitMånSum: 0,

  currentOffertTotal: 0,
  currentOffertProfit: 0,

  currentOffertTotalMån: 0,
  currentOffertProfitMån: 0,
  currentOffertRabbatMån: 0,

  currentOffertTotalKvartal: 0,
  currentOffertProfitKvartal: 0,

  currentOffertTotalÅr: 0,
  currentOffertProfitÅr: 0,
  currentOffertProducts: [],
  OffertProducts: [],

  offerts: [],
  documents: [],

  response: {},

  loading: {
    processing: false,
    msg: ''
  },
  genPdfFlag: 0,

  artiklar: [],
  loadedArt: [],
  searchingArt: false,
  loadingArt: false,
  count: 0,
  docCount: 0,
  bilagor: [],

  newOffertsM: 0,
  antalAvtal: 0,
  antalOfferts: 0,
  passDeadline2M: 0,

  sellsTest: 0,

  FilterOffertPopup:false,
  OffertFilterOption: isUndefined(localStorage.OffertFilter)?[]:JSON.parse(localStorage.OffertFilter),

  OffertLoading: false,

  //Jack
  currentHogiaOffertVardeTooltip:[],
  OffertPage:1,
  OffertpageSize:25,

}




export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_ZERO_OFFERT: {
      return INIT_STATE
    }
    case ON_OPEN_FILTER_OFFERT: {
      console.log("ON_OPEN_FILTER_OFFERT", action.payload)
      return {
        ...state, 
        FilterOffertPopup:true,
        
        OffertFilterOption:isUndefined(localStorage.OffertFilter)?[]:JSON.parse(localStorage.OffertFilter)
      }
    }
    case ON_ClOSE_FILTER_OFFERT: {
      console.log("ON_ClOSE_FILTER_OFFERT", action.payload)
      return {...state, FilterOffertPopup:false}
    }
    case SET_OFFERT_FILTER: {
      console.log("SET_OFFERT_FILTER", action.payload)
      localStorage.removeItem("OffertFilter");
      localStorage.setItem("OffertFilter", JSON.stringify(action.payload));
      return {...state, OffertFilterOption: action.payload}
    }

    case OFFERTPREV_ON_CHECK_TOTAL_SECTIONS_HEIGHT: {
      // console.log("OFFERTPREV_ON_CHECK_TOTAL_SECTIONS_HEIGHT", action.payload)
      let newPages = []
      let pages = JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, ""))
      pages.map(p => {
        let totalHeight = 0
        let footerHeight = 0
        const sections = Array.from(document.querySelectorAll(".p"+p.id+"_section_id"))
        sections.map(s => {
          let height = Number(window.getComputedStyle(s,null).getPropertyValue("height").replace("px", ""))
          // console.log(s.dataset.type)
          if(s.dataset.type !== 'footer')
            totalHeight += Math.round(height)
          else
            footerHeight = Math.round(height)
        })
        // console.log("All sections: "+totalHeight)
        // console.log("Footer: "+totalHeight)
        newPages.push({...p, totalSectionsHeight: totalHeight, footerHeight})
      })

      let newPages2 = []
      let pushNextpage = null
      let productPushNextPage = null

      newPages.map((p, index) => {
        if(p.totalSectionsHeight > (1122-p.footerHeight)) {

          let page = p
          let newPage = null

          let lastSection = null

          for (var i = p.sections.length - 1; i >= 0; i--) {
            if(p.sections[i].type !== 'footer'){
              lastSection = p.sections[i]
              break
            }
          }
          
          let lastSectionHeight = Number(window.getComputedStyle(document.querySelector(".s"+lastSection.id+"_section"),null).getPropertyValue("height").replace("px", ""))
          
          let hasProducts = false
          
          lastSection.col.map((c, index) => {
            if(!isEmpty(c.productData.products)){
              hasProducts = true
            }
          })
          //kolla om det får plats på nästa sida
          if(!isUndefined(newPages[index+1])){
            //om det finns en nästa sida
            if((newPages[index+1].totalSectionsHeight - lastSectionHeight) < (1122-newPages[index+1].footerHeight) && !isUndefined(newPages[index+1].generatedPage)){
              if(!hasProducts) {
                page = {...p, sections: p.sections.filter(s => s.id !== lastSection.id)}
                pushNextpage = { ...lastSection,id: uuidv4(), col: lastSection.col.map(c => {return {...c, id: uuidv4()}})}
              } else {
                page = {...p,
                  sections: p.sections.map(s => {
                    if(s.id === lastSection.id){
                      return {...s, col: s.col.map(c => { 
                        productPushNextPage = c.productData.products[c.productData.products.length -1]
                          return {...c, 
                            type: c.productData.products.slice(0, -1).length === 0 ? 'blank' : c.type,
                            productData: {...c.productData, products: c.productData.products.slice(0, -1)}}
                        
                      })}
                    }
                    else
                      return s
                  })
                }
                pushNextpage = {
                  ...lastSection,
                  id: uuidv4(),
                  linkId: lastSection.id,
                  col: lastSection.col.map(c => {
                    return {
                      ...c,
                      id: uuidv4(),
                      productData: {
                        ...c.productData,
                        products: [c.productData.products.pop()]
                      }
                    }
                  })
                }
              }
            } else {
              if(!hasProducts) {
                page = {...p, sections: p.sections.filter(s => s.id !== lastSection.id)}
                newPage = {...p, generatedPage: true, id: uuidv4(), sections: p.sections.filter(s => s.type === 'header').concat([{...lastSection, id: uuidv4()}]).concat(p.sections.filter(s => s.type === 'footer'))}
              } else {
                page = {...p,
                  sections: p.sections.map(s => {
                    if(s.id === lastSection.id){
                      return {...s, col: s.col.map(c => { 
                        productPushNextPage = c.productData.products[c.productData.products.length -1]
                          return {...c, 
                            type: c.productData.products.slice(0, -1).length === 0 ? 'blank' : c.type,
                            productData: {...c.productData, products: c.productData.products.slice(0, -1)}}
                        
                      })}
                    }
                    else
                      return s
                  })
                }
                newPage = {...p, generatedPage: true, id: uuidv4(), sections: p.sections.filter(s => s.type === 'header').concat([{...lastSection, id: uuidv4(), linkId: lastSection.id, col: lastSection.col.map(c => { return {...c, productData: {...c.productData, products: []}}})}]).concat(p.sections.filter(s => s.type === 'footer'))}
              }
            }
          } else {
            if(!hasProducts) {
              page = {...p, sections: p.sections.filter(s => s.id !== lastSection.id)}
              newPage = {...p, generatedPage: true, id: uuidv4(), sections: p.sections.filter(s => s.type === 'header').concat([{...lastSection, id: uuidv4()}]).concat(p.sections.filter(s => s.type === 'footer'))}
            } else {
              page = {...p,
                sections: p.sections.map(s => {
                  if(s.id === lastSection.id){
                    return {...s, col: s.col.map(c => {
                      productPushNextPage = c.productData.products[c.productData.products.length -1]
                      return {...c, 
                        type: c.productData.products.slice(0, -1).length === 0 ? 'blank' : c.type,
                        productData: {...c.productData, products: c.productData.products.slice(0, -1)}}
                      
                     
                    })}
                  }
                  else
                    return s
                })
              }
              newPage = {...p, generatedPage: true, id: uuidv4(), sections: p.sections.filter(s => s.type === 'header').concat([{...lastSection, id: uuidv4(), linkId: lastSection.id, col: lastSection.col.map(c => { return {...c, productData: {...c.productData, products: []}}})}]).concat(p.sections.filter(s => s.type === 'footer'))}
            }
          }

          newPages2.push(page)
          if(!isNull(newPage)) {
            newPages2.push(newPage)
          } 

        } else {
          if(!isNull(pushNextpage)) {
            //kolla efter linkad sektion
            let linkedSection = null
            if(!isNull(productPushNextPage)){
              for (let s of p.sections) {
                if(s.linkId === pushNextpage.linkId){
                  linkedSection = {...s, col: s.col.map(c => {
                    return {...c, productData: {...c.productData, products: c.productData.products.concat([productPushNextPage])}}
                  })}
                  break
                }
              }
            }
            if(!isNull(linkedSection)){
              let newSections = p.sections.filter(s => s.id !== linkedSection.id)
              let index = indexOf(p.sections, p.sections.find(s => s.id === linkedSection.id))
              newSections.splice(index, 0, linkedSection)
              newPages2.push({...p,
                sections: newSections
              })
            } else {
              newPages2.push({...p,
                sections: [pushNextpage, ...p.sections]
              })
            }
            pushNextpage = null
            productPushNextPage = null
          } else {
            newPages2.push(p)
          }
        }
      })

      return {...state, currentOffert: {...state.currentOffert, Pages: JSON.stringify(newPages2)}}
    }
    case OFFERTPREV_ON_ADD_PAGE: {
      let newPages = []
      let page = action.payload.page
      let section = action.payload.section
      let column = action.payload.column
      let pages = JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, ""))
      pages.map(p => {
        newPages.push(p)
        if(p.id === page.id) {
          newPages.push({...page, totalSectionsHeight: 0, id: uuidv4(), sections: [{...section, id: uuidv4(), col:[{...column, productData: {...column.productData, products: []}}]}]})
        }
      })

      return {...state, currentOffert: {...state.currentOffert, Pages: JSON.stringify(newPages)}}
    }
    case OFFERTPREV_ON_LOAD_AUTO_FILL_INPUT_TYPES: {
      // localStorage.setItem('autoFillTypes', JSON.stringify(action.payload))
      return {...state, currentOffert: {}, autoFillInputTypes: action.payload, inputMap: []}
    }
    case OFFERTPREV_ON_LOAD_AUTO_FILL_INPUT_TYPES_FROM_LS: {
      return {...state,  autoFillInputTypes: JSON.parse(localStorage.getItem('autoFillTypes'))}
    }
    
    case OFFERTPREV_ON_LOAD_CURRENT_OFFERT: {
      return {
        ...state, 
        currentOffert: action.payload, 

        currentOffertTotalMånSum: 0,
        currentOffertProfitMånSum: 0,

        currentOffertTotal: 0, 
        currentOffertProfit: 0,

        currentOffertTotalMån: 0, 
        currentOffertProfitMån: 0,

        currentOffertTotalKvartal: 0, 
        currentOffertProfitKvartal: 0,

        currentOffertTotalÅr: 0, 
        currentOffertProfitÅr: 0,
        
        currentOffertProducts: [],
      }
    }

    case OFFERTPREV_ON_UPDATE_INPUT_FIELD: {
      let rowId = action.payload.rowId
      let cellId = action.payload.cellId

      let pageId = action.payload.pageId
      let sectionId = action.payload.sectionId
      let columnId = action.payload.columnId
      let value = action.payload.value

      // console.log(action.payload)

      let newPages = []
      JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, "")).map(p => {
        let newSections = []
        if(p.id === pageId) {

          p.sections.map(s => {
            let newColumns = []
            if(s.id === sectionId){
              s.col.map(c => {
                if(c.id === columnId) {
                  let newTableData = {}
                  let newCells = []

                  if(rowId === 0) {
                    c.tableData.header.cells.map(c => {
                      if(c.id === cellId){
                        newCells.push({
                          ...c,
                          value: value
                        })
                      }
                      else
                        newCells.push(c)
                    })
                    newTableData = {
                      ...c.tableData,
                      header: {
                        rowId: 0,
                        cells: newCells
                      }
                    }
                  }
                  else {
                    let newRows = []
                    c.tableData.rows.map(r => {
                      if(r.rowId === rowId) {
                        let newCells = []
                        r.cells.map(c => {
                          if(c.id === cellId){
                            newCells.push({
                              ...c,
                              value: value
                            })
                          } else {
                            newCells.push(c)
                          }
                        })
                        newRows.push({...r, cells: newCells})
                      } else {
                        newRows.push(r)
                      }
                    })
                    newTableData = {
                      ...c.tableData,
                      rows: newRows
                    }
                  }
                  newColumns.push({...c, tableData: newTableData})
                } else {
                  newColumns.push(c)
                }
              })
              newSections.push({...s, col: newColumns})
            }
            else {
              newSections.push(s)
            }
          })

          newPages.push({...p, sections: newSections})
        } else {
          newPages.push(p)
        }
      })

      return {...state, currentOffert: {...state.currentOffert, Pages: JSON.stringify(newPages)}}
    }
    case OFFERTPREV_ON_UPDATE_CHECKBOX: {
      let rowId = action.payload.rowId
      let cellId = action.payload.cellId
      let pageId = action.payload.pageId
      let sectionId = action.payload.sectionId
      let columnId = action.payload.columnId
      let value = action.payload.value

      let newPages = []
      JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, "")).map(p => {
        let newSections = []
        if(p.id === pageId) {

          p.sections.map(s => {
            let newColumns = []
            if(s.id === sectionId){
              s.col.map(c => {
                if(c.id === columnId) {
                  let newTableData = {}
                  let newCells = []

                  if(rowId === 0) {
                    c.tableData.header.cells.map(c => {
                      if(c.id === cellId){
                        newCells.push({
                          ...c,
                          checked: value
                        })
                      }
                      else
                        newCells.push(c)
                    })
                    newTableData = {
                      ...c.tableData,
                      header: {
                        rowId: 0,
                        cells: newCells
                      }
                    }
                  }
                  else {
                    let newRows = []
                    c.tableData.rows.map(r => {
                      if(r.rowId === rowId) {
                        let newCells = []
                        r.cells.map(c => {
                          if(c.id === cellId){
                            newCells.push({
                              ...c,
                              checked: value
                            })
                          } else {
                            newCells.push(c)
                          }
                        })
                        newRows.push({...r, cells: newCells})
                      } else {
                        newRows.push(r)
                      }
                    })
                    newTableData = {
                      ...c.tableData,
                      rows: newRows
                    }
                  }
                  newColumns.push({...c, tableData: newTableData})
                } else {
                  newColumns.push(c)
                }
              })
              newSections.push({...s, col: newColumns})
            }
            else {
              newSections.push(s)
            }
          })

          newPages.push({...p, sections: newSections})
        } else {
          newPages.push(p)
        }
      })

      return {...state, currentOffert: {...state.currentOffert, Pages: JSON.stringify(newPages)}}
    }
    
    case OFFERTPREV_ON_ADD_BILAGA: {
      let pages = JSON.parse(action.payload)
      let pagesWithNewId = pages.map(p => {
        return {...p, id: uuidv4()}
      })
      let newPages = JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, "")).concat(pagesWithNewId)
      return {...state, currentOffert: {...state.currentOffert, Pages: JSON.stringify(newPages)}}
    }
    case OFFERTPREV_ON_DELETE_PAGE: {
      let page = action.payload
      let newPages = JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, "")).filter(_page => _page.id !== page.id)
      console.log(page)
      return {...state, currentOffert: {...state.currentOffert, Pages: JSON.stringify(newPages)} }
    }
    case OFFERTPREV_ON_HIDE_PAGE: {
      let page = action.payload.page
      let hidden = action.payload.hidden
      let pages = JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, ""))

      let newPages = pages.filter(p => p.id !== page.id)
      let newPage = {...page, hidden: hidden}
      let pageIndex = indexOf(pages, pages.find(p => p.id === page.id))
      newPages.splice(pageIndex, 0, newPage)
      
      console.log(page)

      return {...state, currentOffert: {...state.currentOffert, Pages: JSON.stringify(newPages)} }
    }
    case OFFERTPREV_ON_ADD_OFFERT: {
      return {...state}
    }
    case OFFERTPREV_ON_START_LOAD_OFFERT: {
      return {...state, currentOffert: {}, currentOffertTotal: 0, currentOffertProfit: 0}
    }
    case OFFERTPREV_ON_LOAD_OFFERT: {
      console.log(action.payload)
      return {...state, 
        currentOffert: action.payload, 
        currentOffertTotalMånSum: action.payload.OffertvalueMån,
        currentOffertProfitMånSum: action.payload.OffertprofitMån,
        currentOffertTotal: action.payload.Offertvalue, 
        currentOffertProfit: action.payload.Offertprofit,
        currentOffertProducts: [],
      
      }
    }
//OFFERTPREV_ON_GET_ALL_OFFERTS
case OFFERTPREV_ON_START_GET_ALL_OFFERTS: {
  console.log("OFFERTPREV_ON_START_GET_ALL_OFFERTS", action.payload)
  return {...state, 
    offerts: [],
    count: 0,
    OffertLoading:true
  }
}
case OFFERTPREV_ON_GET_ALL_OFFERTS: {
  console.log("OFFERTPREV_ON_GET_ALL_OFFERTS", action.payload)
  return {...state, 
    offerts: action.payload.Offerts, 
    count: action.payload.Count,
    currentOffert: {},
    
    OffertLoading:false
  }
}
//OFFERTPREV_ON_GET_AVTAL_OFFERTS
case OFFERTPREV_ON_GET_AVTAL_OFFERTS: {
  console.log("OFFERTPREV_ON_GET_AVTAL_OFFERTS", action.payload)
  return {...state, 
    offerts: action.payload.Offerts, 
    currentOffert: {}
  }
}
//
    case OFFERTPREV_ON_GET_OFFERTS: {
      console.log("OFFERTPREV_ON_GET_OFFERTS", action.payload)
      return {...state, 
        offerts: action.payload.offerts, 
      //  count: action.payload.Count,
        currentOffert: {}
      }
    }
    case OFFERTPREV_ON_SEARCH_OFFERTS: {
      console.log("OFFERTPREV_ON_SEARCH_OFFERTS",action.payload)
      return {...state, 
        offerts: action.payload.offerts,
        count: action.payload.count,
        OffertLoading:false
      }
    }

    case OFFERTPREV_ON_UPDATE_OFFERT: {
      console.log('sparad')
      return state
    }

    case OFFERTPREV_ON_MAP_INPUTS: {
      return {...state, inputMap: action.payload}
    }

    case OFFERTPREV_ON_UPDATE_MAP_INPUTS: {
      console.log(action.payload)
      let inputs = state.inputMap
      let newInputs = []

      inputs.map((i, index)=> {
        if(action.payload.index === index)
          newInputs.push(action.payload.value)
        else
          newInputs.push(i)
      })

      return {...state, inputMap: newInputs}
    }

    case OFFERTPREV_ON_ADD_PRODUCT: {
      
      let pages = JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, ""))

      let product = action.payload.product
      let pageId = action.payload.pageId
      let sectionId = action.payload.sectionId
      let columnId = action.payload.columnId

      
      let newPages = pages.filter(p => p.id !== pageId)
      let newPage = pages.find(p => p.id === pageId)
      let pageIndex = indexOf(pages, pages.find(p => p.id === pageId))

      let newSections = newPage.sections.filter(s => s.id !== sectionId)
      let newSection = newPage.sections.find(s => s.id === sectionId)
      let sectionIndex = indexOf(newPage.sections, newPage.sections.find(s => s.id === sectionId))

      let newColumns = newSection.col.filter(c => c.id !== columnId)
      let newColumn = newSection.col.find(c => c.id === columnId)
      let columnIndex = indexOf(newSection.col, newSection.col.find(c => c.id === columnId))

      let totalPrice = 0
      let totalProfit = 0
      let totalProfitLopande = 0
      let newProducts = newColumn.productData.products
      newProducts.push(product)
      newProducts.map(p => {
        totalPrice += ((p.data.price * p.data.qnt) - ((p.data.discount / 100) * (p.data.price * p.data.qnt)))
        if(p.data.tbLopande === 1) totalProfitLopande += ((p.data.tb * p.data.qnt) - ((p.data.discount / 100) * (p.data.tb * p.data.qnt)))
        else totalProfit += ((p.data.tb * p.data.qnt) - ((p.data.discount / 100) * (p.data.tb * p.data.qnt)))
      })
      let newProductData = {
        ...newColumn.productData,
        products: newProducts,
        totalPrice: totalPrice,
        totalProfit: totalProfit,
        totalProfitLopande: totalProfitLopande
      }
      let updatedColumn = {
        ...newColumn,
        productData: newProductData
      }
      newColumns.splice(columnIndex, 0, updatedColumn)
      let updatedSection = {...newSection, col: newColumns}
      newSections.splice(sectionIndex, 0, updatedSection)
      let updatedPage = {...newPage, sections: newSections}
      newPages.splice(pageIndex, 0, updatedPage)

      // pages.map(p => {
      //   let newSections = []
      //   if(p.id === pageId) {
      //     p.sections.map(s => {
      //       let newColumns = []
      //       if(s.id === sectionId){
      //         s.col.map(c => {
      //           if(c.id === columnId) {
      //             let totalPrice = 0
      //             let totalProfit = 0
      //             let newProductData = {}

      //             let newProducts = c.productData.products
      //             newProducts.push(product)
      //             newProducts.map(p => {
      //               totalPrice += ((p.data.price * p.data.qnt) - ((p.data.discount / 100) * (p.data.price * p.data.qnt)))
      //               totalProfit += ((p.data.tb * p.data.qnt) - ((p.data.discount / 100) * (p.data.tb * p.data.qnt)))
      //             })

      //             newProductData = {
      //               ...c.productData,
      //               products: newProducts,
      //               totalPrice: totalPrice,
      //               totalProfit: totalProfit
      //             }
      //             newColumns.push({...c, productData: newProductData})
      //           } else {
      //             newColumns.push(c)
      //           }
      //         })
      //         newSections.push({...s, col: newColumns})
      //       }
      //       else {
      //         newSections.push(s)
      //       }
      //     })
      //     newPages.push({...p, sections: newSections})
      //   } else {
      //     newPages.push(p)
      //   }
      // })
      return {...state, currentOffert: {...state.currentOffert, Pages: JSON.stringify(newPages)}}
    }
    case OFFERTPREV_ON_CHANGE_AVTALSTID: {
      
      let pages = JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, ""))

      let AvtalsTid = action.payload.AvtalsTid
      let pageId = action.payload.pageId
      let sectionId = action.payload.sectionId
      let columnId = action.payload.columnId

      
      let newPages = pages.filter(p => p.id !== pageId)
      let newPage = pages.find(p => p.id === pageId)
      let pageIndex = indexOf(pages, pages.find(p => p.id === pageId))

      let newSections = newPage.sections.filter(s => s.id !== sectionId)
      let newSection = newPage.sections.find(s => s.id === sectionId)
      let sectionIndex = indexOf(newPage.sections, newPage.sections.find(s => s.id === sectionId))

      let newColumns = newSection.col.filter(c => c.id !== columnId)
      let newColumn = newSection.col.find(c => c.id === columnId)
      let columnIndex = indexOf(newSection.col, newSection.col.find(c => c.id === columnId))

      let newProductData = {
        ...newColumn.productData,
        selectedTidsval: AvtalsTid
      }
      let updatedColumn = {
        ...newColumn,
        productData: newProductData
      }
      newColumns.splice(columnIndex, 0, updatedColumn)
      let updatedSection = {...newSection, col: newColumns}
      newSections.splice(sectionIndex, 0, updatedSection)
      let updatedPage = {...newPage, sections: newSections}
      newPages.splice(pageIndex, 0, updatedPage)

      return {...state, currentOffert: {...state.currentOffert, Pages: JSON.stringify(newPages)}}
    }

    case OFFERTPREV_ON_DELETE_PRODUCT: {
      let pages = JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, ""))
      let product = action.payload.product
      let pageId = action.payload.pageId
      let sectionId = action.payload.sectionId
      let columnId = action.payload.columnId

      let newPages = []

      pages.map(p => {
        let newSections = []
        if(p.id === pageId) {
          p.sections.map(s => {
            let newColumns = []
            if(s.id === sectionId){
              s.col.map(c => {
                if(c.id === columnId) {
                  let newProductData = {}
                  let newProducts = []
                  let totalPrice = 0
                  let totalProfit = 0
                  c.productData.products.map(p => {
                    if(p.id !== product.id)
                      newProducts.push(p)
                  })
                  newProducts.map(p => {
                    totalPrice += ((p.data.price * p.data.qnt) - ((p.data.discount / 100) * (p.data.price * p.data.qnt)))
                    totalProfit += ((p.data.tb * p.data.qnt) - ((p.data.discount / 100) * (p.data.tb * p.data.qnt)))
                  })
                  newProductData = {
                    ...c.productData,
                    products: newProducts,
                    totalPrice: totalPrice,
                    totalProfit: totalProfit
                  }
                  newColumns.push({...c, productData: newProductData})
                } else {
                  newColumns.push(c)
                }
              })
              newSections.push({...s, col: newColumns})
            }
            else {
              newSections.push(s)
            }
          })
          newPages.push({...p, sections: newSections})
        } else {
          newPages.push(p)
        }
      })
      return {...state, currentOffert: {...state.currentOffert, Pages: JSON.stringify(newPages)}}
    }

    case OFFERTPREV_ON_CHANGE_PRODUCT_QNT: {
      let pages = JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, ""))
      let product = action.payload.product
      let change = action.payload.change
      let pageId = action.payload.pageId
      let sectionId = action.payload.sectionId
      let columnId = action.payload.columnId
      let newPages = []

      pages.map(p => {
        let newSections = []
        if(p.id === pageId) {
          p.sections.map(s => {
            let newColumns = []
            if(s.id === sectionId){
              s.col.map(c => {
                if(c.id === columnId) {
                  let newProductData = {}
                  let newProducts = []
                  let totalPrice = 0
                  let totalProfit = 0
                  c.productData.products.map(p => {
                    if(p.id === product.id){
                      newProducts.push({
                        ...p,
                        data: {
                          ...p.data,
                          qnt: p.data.qnt += change
                        }
                      })
                    } else {
                      newProducts.push(p)
                    }
                  })
                  
                  newProducts.map(p => {
                    totalPrice += ((p.data.price * p.data.qnt) - ((p.data.discount / 100) * (p.data.price * p.data.qnt)))
                    totalProfit += ((p.data.tb * p.data.qnt) - ((p.data.discount / 100) * (p.data.tb * p.data.qnt)))
                  })
                  newProductData = {
                    ...c.productData,
                    products: newProducts,
                    totalPrice: totalPrice,
                    totalProfit: totalProfit
                  }
                  newColumns.push({...c, productData: newProductData})
                } else {
                  newColumns.push(c)
                }
              })
              newSections.push({...s, col: newColumns})
            }
            else {
              newSections.push(s)
            }
          })
          newPages.push({...p, sections: newSections})
        } else {
          newPages.push(p)
        }
      })
      return {...state, currentOffert: {...state.currentOffert, Pages: JSON.stringify(newPages)}}
    }

    case OFFERTPREV_ON_SET_PRODUCT_QNT: {
      let pages = JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, ""))
      let product = action.payload.product
      let change = action.payload.change
      let pageId = action.payload.pageId
      let sectionId = action.payload.sectionId
      let columnId = action.payload.columnId
      let newPages = []

      pages.map(p => {
        let newSections = []
        if(p.id === pageId) {
          p.sections.map(s => {
            let newColumns = []
            if(s.id === sectionId){
              s.col.map(c => {
                if(c.id === columnId) {
                  let newProductData = {}
                  let newProducts = []
                  let totalPrice = 0
                  let totalProfit = 0
                  c.productData.products.map(p => {
                    if(p.id === product.id){
                      newProducts.push({
                        ...p,
                        data: {
                          ...p.data,
                          qnt: change
                        }
                      })
                    } else {
                      newProducts.push(p)
                    }
                  })
                  
                  newProducts.map(p => {
                    totalPrice += ((p.data.price * p.data.qnt) - ((p.data.discount / 100) * (p.data.price * p.data.qnt)))
                    totalProfit += ((p.data.tb * p.data.qnt) - ((p.data.discount / 100) * (p.data.tb * p.data.qnt)))
                  })
                  newProductData = {
                    ...c.productData,
                    products: newProducts,
                    totalPrice: totalPrice,
                    totalProfit: totalProfit
                  }
                  newColumns.push({...c, productData: newProductData})
                } else {
                  newColumns.push(c)
                }
              })
              newSections.push({...s, col: newColumns})
            }
            else {
              newSections.push(s)
            }
          })
          newPages.push({...p, sections: newSections})
        } else {
          newPages.push(p)
        }
      })
      return {...state, currentOffert: {...state.currentOffert, Pages: JSON.stringify(newPages)}}
    }

    case OFFERTPREV_ON_CHANGE_PRODUCT: {
      let pages = JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, ""))
      let product = action.payload.product
      let pageId = action.payload.pageId
      let sectionId = action.payload.sectionId
      let columnId = action.payload.columnId


      
      let newPages = []

      pages.map(p => {
        let newSections = []
        if(p.id === pageId) {
          p.sections.map(s => {
            let newColumns = []
            if(s.id === sectionId){
              s.col.map(c => {
                if(c.id === columnId) {
                  let newProductData = {}
                  let newProducts = []
                  let totalPrice = 0
                  let totalProfit = 0
                  c.productData.products.map(p => {

                    console.log(p)

                    if(p.id === product.id){
                      newProducts.push({
                        ...p,
                        data: {
                          ...product.data,
                        }
                      })
                      // console.log({
                      //   ...p,
                      //   data: {
                      //     ...product.data,
                      //   }
                      // })
                    } else {
                      newProducts.push(p)
                    }
                  })
                  newProducts.map(p => {
                    totalPrice += ((p.data.price * p.data.qnt) - ((p.data.discount / 100) * (p.data.price * p.data.qnt)))
                    totalProfit += ((p.data.tb * p.data.qnt) - ((p.data.discount / 100) * (p.data.tb * p.data.qnt)))
                  })
                  newProductData = {
                    ...c.productData,
                    products: newProducts,
                    totalPrice: totalPrice,
                    totalProfit: totalProfit
                  }
                  newColumns.push({...c, productData: newProductData})
                } else {
                  newColumns.push(c)
                }
              })
              newSections.push({...s, col: newColumns})
            }
            else {
              newSections.push(s)
            }
          })
          newPages.push({...p, sections: newSections})
        } else {
          newPages.push(p)
        }
      })
      return {...state, currentOffert: {...state.currentOffert, Pages: JSON.stringify(newPages)}}
    }

    case OFFERTPREV_ON_LOAD_ARTIKLAR: {
      return {...state, artiklar: action.payload, loadingArt: false }
    }
    case OFFERTPREV_ON_ERROR_LOAD_ARTIKLAR: {
      return {...state, artiklar: [], loadingArt: false}
    }
    case OFFERTPREV_ON_START_LOAD_ARTIKLAR: {
      return {...state, loadingArt: true}
    }
    case OFFERTPREV_ON_GET_OFFERT_COUNT:{
      console.log('OFFERTPREV_ON_GET_OFFERT_COUNT', action)
      // console.log(action.payload[0]["COUNT(*)"])
      return { ...state, count: action.payload[0]["COUNT(*)"]};
    }

    case OFFERTPREV_ON_GET_DOCUMENTS:{
      console.log('OFFERTPREV_ON_GET_DOCUMENTS', action)
      // console.log(action.payload[0]["COUNT(*)"])
      return { ...state, docCount: action.payload.count[0]["COUNT(*)"], documents: action.payload.documents };
    }

    case OFFERTPREV_ON_SET_CUSTOMER: {
      // localStorage.setItem('selectedKund', JSON.stringify(action.payload))
      return {...state, selectedKund: action.payload}
    }
    case OFFERTPREV_LOAD_SELECTED_CUSTOMER: {
      return {...state, selectedKund: JSON.parse(localStorage.getItem('selectedKund'))}
    }

    case OFFERTPREV_ON_SUM_TOTAL: {
      let pages = JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, ""))
      let offertProducts = []

      let total = 0
      let profit = 0

      let totalMån = 0
      let profitMån = 0

      let rabbatMån = 0

      let totalKvartal = 0
      let profitKvartal = 0

      let totalÅr = 0
      let profitÅr = 0

      pages.map(p => {
        p.sections.map(s => {
          s.col.map(c => {
            if(!isUndefined(c.productData)){
              let opt = c.productData.ongoingopt
              let ongoing  = c.productData.ongoing
              // if(c.productData.totalPrice !== undefined && !ongoing){
              //   total += c.productData.totalPrice
              //   profit += c.productData.totalProfit 
              // }
              // if(c.productData.totalPrice !== undefined && ongoing && opt === 1){
              //   totalMån += c.productData.totalPrice 
              //   profitMån += c.productData.totalProfit 
              // }
              // if(c.productData.totalPrice !== undefined && ongoing && opt === 2){
              //   totalKvartal += c.productData.totalPrice
              //   profitKvartal += c.productData.totalProfit 
              // }
              // if(c.productData.totalPrice !== undefined && ongoing && opt === 3){
              //   totalÅr += c.productData.totalPrice
              //   profitÅr += c.productData.totalProfit 
              // }
              if(!isUndefined(c.productData.products)) {
                c.productData.products.map(p => {
                  // if(offertProducts.find(o => o.id === p.data.id) && p.data.id !== 0){
                  //   let index = offertProducts.indexOf(offertProducts.find(o => o.id === p.data.id))
                  //   offertProducts[index].qnt = offertProducts[index].qnt+ p.data.qnt
                  // } else 
                  // if(p.data.id !== 0){
                    offertProducts.push({
                      id: p.data.id,
                      qnt: p.data.qnt,
                      subProducts: p.data.subProducts,
                      price: parseFloat(p.data.price)
                    })
                    let product = p.data
                    console.log(product)
                    let productPrice = ((parseFloat(product.price) * product.qnt) - ((product.discount / 100) * (parseFloat(product.price) * product.qnt)))
                    let productTb = ((parseFloat(product.tb) * product.qnt) - ((product.discount / 100) * (parseFloat(product.tb) * product.qnt)))
                    // console.log(product.FM)
                    console.log(product)

                    if(!isEmpty(product.subProducts)){
                      product.subProducts.map(sp => {
                        let mån = isUndefined(sp.FM) ? 0 : sp.FM
                        if(mån > 0){
                          rabbatMån -= mån * productPrice
                        }
                      })
                    }
                    if(!isEmpty(product.subProducts2)){
                      product.subProducts2.map(sp => {
                        let mån = isUndefined(sp.FM) ? 0 : sp.FM
                        if(mån > 0){
                          rabbatMån += mån * parseFloat(sp.price) * product.qnt
                        }
                      })
                    }
                    if(!isEmpty(product.subProducts3)){
                      product.subProducts3.map(sp => {
                        let mån = isUndefined(sp.FM) ? 0 : sp.FM
                        if(mån > 0){
                          rabbatMån += mån * parseFloat(sp.price) * product.qnt
                        }
                      })
                    }

                    if(product.FM > 0){
                      let mån = isUndefined(product.FM) ? 0 : product.FM
                      rabbatMån += mån * productPrice
                      if(product.tbLopande === 1) profitMån += productTb
                      else profit += productTb
                    }
                    else if(!ongoing){
                      total += productPrice
                      if(product.tbLopande === 1) profitMån += productTb
                      else profit += productTb
                    }
                    else if(ongoing && opt === 1){
                      totalMån += productPrice
                      if(product.tbLopande === 1) profitMån += productTb
                      else profit += productTb
                    }
                    else if(ongoing && opt === 2){
                      totalMån += productPrice / 4
                      if(product.tbLopande === 1) profitMån += productTb / 4
                      else profit += productTb
                    }
                    else if(ongoing && opt === 3 ){
                      totalMån += productPrice / 12
                      if(product.tbLopande === 1) profitMån += productTb / 12
                      else profit += productTb 
                    }
                  // }
                })
              }
            }
          })
        })
      })

      // let _currentOffertTotalMånSum = totalMån + (totalKvartal / 4) + (totalÅr / 12)
      // let _currentOffertProfitMånSum = profitMån + (profitKvartal / 4) + (profitÅr / 12)
      let _currentOffertTotalMånSum = totalMån
      let _currentOffertProfitMånSum = profitMån

      return {
        ...state, 

        currentOffertTotalMånSum: _currentOffertTotalMånSum,
        currentOffertProfitMånSum: _currentOffertProfitMånSum,

        currentOffertTotal: total, 
        currentOffertProfit: profit,

        currentOffertTotalMån: totalMån, 
        currentOffertProfitMån: profitMån,
        currentOffertRabbatMån: rabbatMån,

        currentOffertTotalKvartal: totalKvartal, 
        currentOffertProfitKvartal: profitKvartal,

        currentOffertTotalÅr: totalÅr, 
        currentOffertProfitÅr: profitÅr,
        
        currentOffertProducts: offertProducts,
      }
    }
    case OFFERTPREV_ON_CHANGE_EDIT_TEXT: {
      let pages = JSON.parse(state.currentOffert.Pages.replace(/(\r\n|\n|\r)/gm, ""))
      let value = action.payload.value
      let pageId = action.payload.pageId
      let sectionId = action.payload.sectionId
      let columnId = action.payload.columnId

      let newPages = []

      pages.map(p => {
        let newSections = []
        if(p.id === pageId) {
          p.sections.map(s => {
            let newColumns = []
            if(s.id === sectionId){
              s.col.map(c => {
                if(c.id === columnId) {
                  newColumns.push({...c, text: value})
                } else {
                  newColumns.push(c)
                }
              })
              newSections.push({...s, col: newColumns})
            }
            else {
              newSections.push(s)
            }
          })
          newPages.push({...p, sections: newSections})
        } else {
          newPages.push(p)
        }
      })
      return {...state, currentOffert: {...state.currentOffert, Pages: JSON.stringify(newPages)}}
    }

    case OFFERTPREV_ON_RESPOSE: {
      return {...state, response: action.payload}
    }

    case OFFERTPREV_ON_RESPOSE_RESET: {
      return {...state, response: {...state.response, show: false}}
    }
    case OFFERTPREV_ON_SET_LOADING: {
      return {...state, loading: {processing: true, msg: action.payload}, genPdfFlag: 1}
    }
    case OFFERTPREV_ON_SET_LOADING_DONE: {
      return {...state, loading: {processing: false, msg: ''}, genPdfFlag: 0}
    }
    case OFFERTPREV_ON_FETCH_ART: {

      if(!state.loadedArt.find(art => art.id === action.payload.id))
        return {...state, loadedArt: state.loadedArt.concat(action.payload)}
      else
        return state
    }
    case OFFERTPREV_ON_START_SEARCH_ART: {
      return  {...state, searchingArt: true, artiklar: []}
    }
    case OFFERTPREV_ON_SEARCH_ART: {
      return {...state, searchingArt: false, artiklar: action.payload}
    }
    case OFFERTPREV_ON_GET_STATS: {
      console.log("Stats: ")
      console.log(action.payload)


      return { ...state,
        newOffertsM: action.payload.newOffertsM,
        antalAvtal: action.payload.antalAvtal,
        antalOfferts: action.payload.antalOfferts,
        passDeadline2M: action.payload.passDeadline,
        sellsTest: action.payload.sellsArray,
        OffertProducts: action.payload._products
      }
    }
    case OFFERTPREV_ON_GET_BILAGOR: {
      return {
        ...state, bilagor: action.payload
      }
    }
 //ON_START_GET_OFFERT_HOGIA_VARDE_TOOLTIP,ON_GET_OFFERT_HOGIA_VARDE_TOOLTIP,ON_ERROR_GET_OFFERT_HOGIA_VARDE_TOOLTIP,
 case ON_START_GET_OFFERT_HOGIA_VARDE_TOOLTIP: {
  console.log("ON_START_GET_ORDER_VARDE_TOOLTIP", action.payload)
  return {
    ...state,
    currentHogiaOffertVardeTooltip:[]
  }
}
case ON_ERROR_GET_OFFERT_HOGIA_VARDE_TOOLTIP: {
  console.log("ON_ERROR_GET_ORDER_VARDE_TOOLTIP", action.payload)
  return {
    ...state,
    currentHogiaOffertVardeTooltip:[]
  }
}
case ON_GET_OFFERT_HOGIA_VARDE_TOOLTIP: {
  console.log("ON_GET_ORDER_VARDE_TOOLTIP", action.payload)
  return {
    ...state,
    currentHogiaOffertVardeTooltip: action.payload.OffertHogiaVardeTooltip
  }
}
 //   ON_GET_OFFERT_PAGE_BASIC
 case ON_GET_OFFERT_PAGE_BASIC: {
  console.log(action.payload,"DADADAD")
  return {...state,
    OffertPage:action.payload.Page
  }
}
 //OffertPage
 case ON_GET_OFFERT_PAGE_SIZE_BASIC: {
  console.log(action.payload,"DADADAD")
  return {...state,
    OffertpageSize:action.payload.Page
  }
}
 //OffertpageSize
    default:
      return state;  
  }
}